/* eslint-disable */

import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Container,
  Image,
  Button,
  Grid,
  Form,
  Segment,
  Divider
} from 'semantic-ui-react';

import * as AppActions from '../../actions';
import Images from '../../assets/Images';
import LoginLinks from './LoginLinks';

class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      message: '',
      password: '',
      changePassword: ''
    };
  }
  login = async (event) => {
    event.preventDefault();
    const { actions, user } = this.props;
    const { username, password, changePassword } = this.state;
    if (user.loading) return;
    try {
      await actions.login({ username, password, changePassword });
      this.props.userLogged();
      localStorage.setItem('tokenLastUpdate', new Date());
    } catch (error) {
      console.log(error);
      this.setState({ message: error.message });
    }
  };

  loginForm = () => (
    <div className="container">
      <div>
        <Grid>
          <Grid.Column>
            <Segment className="rounded-container">
              <Form className="Login-form" onSubmit={this.login}>
                <Form.Field>
                  <input
                    placeholder="Username"
                    id="username"
                    className="format-login-input"
                    onChange={(event) =>
                      this.setState({ username: event.target.value })
                    }
                    type="text"
                  />
                </Form.Field>
                <Form.Field>
                  <input
                    placeholder="Password"
                    id="password"
                    className="format-login-input"
                    onChange={(event) =>
                      this.setState({ password: event.target.value })
                    }
                    type="password"
                  />
                </Form.Field>
                <Divider hidden />
                <Button
                  type="submit"
                  color="black"
                  className="login-button"
                  fluid
                >
                  LOG IN
                </Button>
              </Form>
              <Divider hidden />
              <LoginLinks
                handleSwitchForm={this.props.handleSwitchForm}
                currentPage="login"
              />
              <div className="login-error">{this.state.message}</div>
            </Segment>
          </Grid.Column>
        </Grid>
      </div>
    </div>
  );
  render() {
    const { user } = this.props;
    return this.loginForm();
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginForm);



// WEBPACK FOOTER //
// ./src/screens/Auth/LoginForm.js